import gql from 'graphql-tag';

const CUSTOMER_ASKS = gql`
  fragment CustomerAsks on AsksConnection {
    edges {
      node {
        id
        amount
      }
    }
    pageInfo {
      totalCount
    }
  }
`;

const FETCH_CUSTOMER_ASKS_FOR_PRODUCT = gql`
  query FetchCustomerAsksForProduct(
    $productId: String!
    $currencyCode: CurrencyCode
    $isVariant: Boolean! = false
  ) {
    variantAsk: viewer @include(if: $isVariant) {
      uuid
      asks(
        currencyCode: $currencyCode
        filters: { variantId: { in: [$productId] }, expired: { is: false } }
        first: 1
        order: ASC
        state: CURRENT
        sort: PRICE
      ) {
        ...CustomerAsks
      }
    }

    parentAsk: viewer @skip(if: $isVariant) {
      uuid
      asks(
        currencyCode: $currencyCode
        filters: { productId: { in: [$productId] }, expired: { is: false } }
        first: 1
        order: ASC
        state: CURRENT
        sort: PRICE
      ) {
        ...CustomerAsks
      }
    }
  }
  ${CUSTOMER_ASKS}
`;

export default FETCH_CUSTOMER_ASKS_FOR_PRODUCT;
